import React, { Component } from "react";
//PrimeReact Components
import * as pr from "../../common/PrimeComponents";
//Common Functions
import { auth } from "../../common/helpers/auth";

class Register extends Component {
  state = {
    email: "",
    password: "",
    showPassword: false,
    confirmPassword: "",
    showConfirmPassword: false
  };

  handleSubmitRegister = () => {
    this.growl.clear();
    if (this.state.password === this.state.confirmPassword) {
      auth(this.state.email, this.state.password)
        .then(() => {
          this.growl.show({
            severity: "success",
            summary: <br />,
            detail: "Success: The user was registered.",
            life: 3000
          });
          this.setState({ email: "", password: "", confirmPassword: "" });
        })
        .catch(error => {
          this.growl.show({
            severity: "error",
            summary: <br />,
            detail: error.toString(),
            life: 3000
          });
        });
    } else {
      this.growl.show({
        severity: "error",
        summary: <br />,
        detail: "Error: The password does not match the confirm password.",
        life: 3000
      });
    }
  };

  handleKeyPress = e => {
    if (e.key === "Enter") {
      this.handleSubmitRegister();
    }
  };

  render() {
    const s = this.state;

    return (
      <div className="login-body" onKeyPress={this.handleKeyPress}>
        <div className="ui-g">
          <div
            className="card login-panel ui-fluid"
            style={{ background: "#043066" }}
          >
            <pr.Growl
              style={{ textAlign: "left" }}
              ref={el => (this.growl = el)}
            />
            <div className="ui-g">
              <div className="ui-g-12">
                <img
                  src="/assets/layout/images/capcon/logo.png"
                  alt=""
                  height="100%"
                  width="100%"
                />
              </div>
              <div className="ui-g-12">
                <span
                  className="md-inputfield form-field"
                  style={{ marginTop: "0px" }}
                >
                  <pr.InputText
                    id="float-input-email"
                    style={{ color: "white", background: "transparent" }}
                    value={s.email || ""}
                    onChange={e =>
                      this.setState({
                        email: e.target.value
                      })
                    }
                  />
                  <label htmlFor="float-input-email" style={{ color: "white" }}>
                    Email Address
                  </label>
                </span>
              </div>
              <div className="ui-g-12">
                <div className="ui-g-10" style={{ padding: "0" }}>
                  <span
                    className="md-inputfield form-field"
                    style={{ marginTop: "0px" }}
                  >
                    {s.showPassword === false ? (
                      <pr.Password
                        id="float-input-password"
                        feedback={true}
                        style={{ color: "white", background: "transparent" }}
                        promptLabel="Strength"
                        value={s.password || ""}
                        onChange={e =>
                          this.setState({
                            password: e.target.value
                          })
                        }
                      />
                    ) : (
                      <pr.InputText
                        id="float-input-password"
                        style={{ color: "white" }}
                        value={s.password || ""}
                        onChange={e =>
                          this.setState({
                            password: e.target.value
                          })
                        }
                      />
                    )}
                    <label
                      htmlFor="float-input-password"
                      style={{ color: "white" }}
                    >
                      Password
                    </label>
                  </span>
                </div>
                <div className="ui-g-2">
                  <pr.Button
                    icon={
                      s.showPassword === true ? "pi pi-eye-slash" : "pi pi-eye"
                    }
                    onClick={() => {
                      this.setState({ showPassword: !s.showPassword });
                    }}
                    style={{ margin: "0" }}
                  />
                </div>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "0" }}>
                <div className="ui-g-10" style={{ padding: "0" }}>
                  <span
                    className="md-inputfield form-field"
                    style={{ marginTop: "0px" }}
                  >
                    {s.showConfirmPassword === false ? (
                      <pr.Password
                        id="float-input-password-confirm"
                        feedback={false}
                        style={{ color: "white", background: "transparent" }}
                        promptLabel="Strength"
                        value={s.confirmPassword || ""}
                        onChange={e =>
                          this.setState({
                            confirmPassword: e.target.value
                          })
                        }
                      />
                    ) : (
                      <pr.InputText
                        style={{ color: "white" }}
                        id="float-input-password-confirm"
                        value={s.confirmPassword || ""}
                        onChange={e =>
                          this.setState({
                            confirmPassword: e.target.value
                          })
                        }
                      />
                    )}
                    <label
                      htmlFor="float-input-password-confirm"
                      style={{ color: "white" }}
                    >
                      Confirm Password
                    </label>
                  </span>
                </div>
                <div className="ui-g-2">
                  <pr.Button
                    icon={
                      s.showConfirmPassword === true
                        ? "pi pi-eye-slash"
                        : "pi pi-eye"
                    }
                    onClick={() => {
                      this.setState({
                        showConfirmPassword: !s.showConfirmPassword
                      });
                    }}
                    style={{ margin: "0" }}
                  />
                </div>
              </div>
              <div className="ui-g-12" style={{ paddingTop: "0" }}>
                <pr.Button
                  icon="pi pi-user-plus"
                  label="Register"
                  onClick={() => {
                    this.handleSubmitRegister();
                  }}
                />
                <a href="#/" style={{ color: "white" }}>
                  Already Registered?
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Register;



// WEBPACK FOOTER //
// ./src/components/Register/Register.js